import React from 'react';

// livelogs icon with adaptable size and color
// to center/position place inside of a div
interface ILiveLogsIconProps {
  fill: string;
  width: string;
  height: string;
}

export const LiveLogsIcon = (props: ILiveLogsIconProps) => {
  const { fill, width, height } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={'0 0 13 12'}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M7.9983 0L0 0L0 1.79796H7.9983V0Z' fill={fill} />
      <path d='M6.27144 3.14648H0.00683594V4.94445H6.27144V3.14648Z' fill={fill} />
      <path d='M13 6.29297H0L0 8.09093H13V6.29297Z' fill={fill} />
      <path d='M9.76748 9.44727H0.00683594V11.2452H9.76748V9.44727Z' fill={fill} />
    </svg>
  );
};
